import React from "react";

import { WALLET_ICON } from "src/constants/images";

const WalletLogin = ({ onClick }) => (
  <div className="connect">
    <h4>Connect Your Wallet</h4>
    <div className="mt-5 mb-3 text-center">
      <img src={WALLET_ICON.SOURCE} alt="connect wallet" style={{scale: "5"}} />
    </div>
    <p>
    You need a wallet to interact with the platform. <br /> If you do not have ICONex installed, please download from
        <a
          target="_blank"
          href="https://chrome.google.com/webstore/detail/iconex/flpiciilemghbmfalicajoolhkkenfel?hl=en"
          onClick={onClick}
        >
          {" "}
          <strong> here</strong>{" "}
        </a>{" "}
        and try again.
    </p>
    <button className="btn btn-primary wallet-button my-2" onClick={onClick}>
      Connect Wallet
    </button>
  </div>
);

export default WalletLogin;
